export class BrowserCache {
  static save<T>(key: string, value: T, lifetimeMins?: number, useSession = false): void {
    const storage = useSession ? sessionStorage : localStorage;
    const expiresAt = lifetimeMins ? Date.now() + lifetimeMins * 60_000 : null;
    const wrapped = { value, expiresAt };
    storage.setItem(key, JSON.stringify(wrapped));
  }

  static load<T>(key: string, useSession = false): T | null {
    const storage = useSession ? sessionStorage : localStorage;
    const item = storage.getItem(key);

    if (!item) {
      return null;
    }

    try {
      const parsed = JSON.parse(item);

      if (parsed.expiresAt && Date.now() > parsed.expiresAt) {
        storage.removeItem(key);
        return null;
      }

      return parsed.value as T;
    } catch {
      storage.removeItem(key);
      return null;
    }
  }

  static clear(key: string, useSession = false): void {
    const storage = useSession ? sessionStorage : localStorage;
    storage.removeItem(key);
  }

  static clearAll(useSession = false): void {
    sessionStorage.clear();
    localStorage.clear();
  }
}
